// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ed-flow[data-v-ded87f9c]{padding-top:16px}.ed-flow-none[data-v-ded87f9c]{text-align:center;font-size:15px}", ""]);
// Exports
module.exports = exports;
